import React, {useEffect, useState} from "react";
import {WidgetProps} from "../../widget";
import {Select} from "antd";
import {ResponsiblePerson} from "../../../../../../../models/ic/ic";
import {icService} from "../../../../../../../services/ic/ic.service";

export const UIInputWidgetResponsiblePerson: React.FC<WidgetProps> = ({value, onChange, multiple}) => {

    const [persons, setPersons] = useState<ResponsiblePerson[]>([]);

    useEffect(() => {
        icService.getAllPersons().then(data => {
            setPersons(data);
        });
    }, []);

    return (
        <Select
            mode={multiple ? "multiple" : undefined}
            onChange={onChange as any}
            value={value as any}
            allowClear={true}
            showSearch
            optionFilterProp={"children"}
        >
            {persons.map(person =>
                <Select.Option key={person.id} value={person.id}>{person.name}</Select.Option>)}
        </Select>
    )
}